import { Locales } from "localization/types";
import { UserBuddyStatus } from "pages/employee/types";
import { UserRole } from "types";

export enum UserPreferredLocale {
	EN = "en",
	NL = "nl",
}

export enum ONBOARDING_STEP {
	USER = "user",
	ORGANIZATION = "organization",
	THEME = "theme",
}

export enum UserGender {
	MALE = "male",
	FEMALE = "female",
	OTHER = "other",
	NOT_DISCLOSE = "not-disclose",
}

export interface User {
	id: string;
	username: string;
	name: string;
	email: string;
	role: UserRole;
	preferredLocale: Locales;
	isEmailVerified: Boolean;
	buddyStatus: UserBuddyStatus;
	isBuddy: Boolean;
	phoneNumber: string;
	birthDate: string;
	profilePicture: string;
	gender: UserGender;
	/** Job title key. Still need to be parsed */
	jobTitle: string;
	/** User is in Test Mode */
	isTestMode?: boolean;
}

export interface RegisterAccountPayload {
	email: string;
	password: string;
	preferredLocale?: Locales;
	/**
	 * TOS stands for Terms of Service
	 * tosAccepted is a boolean to check if the user has accepted the TOS
	 */
	tosAccepted: boolean;
	allowStatistics: boolean;
}

export interface Organization {
	_id: string;
	name: string;
	companySize: number;
	industry: string;
	logoURI: string;
	backgroundURI: string;
	isOnboardingCompleted: Boolean;
	theme: {
		_id: string;
		color: {
			primary: {
				main: string;
				light: string;
			};
			secondary: {
				main: string;
				light: string;
			};
		};
	};
	slug: string;
	websiteUrl?: string;
	careerPageUrl?: string;
	linkedInUrl?: string;
}

export type VerificationResult = "success" | "failed";
